import React, { Component } from 'react';

import request from '../client/client';

class FormCashier extends Component {

  state = {
    criarCashierError: null
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  criarCashier = async (e) => {
    e.preventDefault();

    try {
      await request.post('/items', {
        "email": this.state.email,
        "password": this.state.password,
        "workplace": this.state.workplace


      })
    } catch (err) {
      console.log(err);
      this.setState({
        /* Adicionar tratamento de erro mais específico */
        criarCashierError: "Cashier não pode ser adicionado"
      })
    };
  }

  render() {
    return (
      <div className="text-center">
        <form onSubmit={this.criarCashier}>
          <input
            className="form-item"
            placeholder="Email"
            name="email"
            type="text"
            onChange={this.handleChange}
          />
          <input
            className="form-item"
            placeholder="Senha"
            name="password"
            type="password"
            onChange={this.handleChange}
          />
          <input
            className="form-item"
            placeholder="Workplace"
            name="workplace"
            type="text"
            onChange={this.handleChange}
          />
          {
            !!this.state.criarCashierError &&
            <div className="error-message">
              {this.state.criarCashierError}
            </div>
          }
          <input
            className="form-submit"
            value="Enviar"
            type="submit"
          />
        </form>
      </div>
    )
  }
}

export default FormCashier;



// WEBPACK FOOTER //
// ./src/components/form-cashier/index.js